module.exports = __webpack_public_path__ + "img/logo.f4ae2ed6.png";